import { ContractLanguageSection } from "components/ContractLanguageSection";
import {
  IRuleAttachment,
  RuleType,
} from "components/ContractLanguageSection/types";
import { Message } from "primereact/message";
import { Controller, useFormContext } from "react-hook-form";

import { useRuleBucket } from "../hooks/useRuleBucket";

interface IContractLanguageFieldProps {
  ruleType: RuleType;
  ruleId?: string;
  attachments?: IRuleAttachment[];
}

/** RHF wrapper around ContractLanguageSection used by MPPR / Case Rate / Package forms. */
export function ContractLanguageField({
  ruleType,
  ruleId,
  attachments,
}: IContractLanguageFieldProps) {
  const { control } = useFormContext();
  // CLE-2842 — contract language and attachments belong to one payer's row, so a group edit leaves
  // them alone; they are shown read-only until the scope is "Only this payer".
  const bucket = useRuleBucket();
  const readOnly = !!bucket?.isGroupScope;
  return (
    <>
      {readOnly && bucket && (
        <Message
          severity="info"
          className="w-full justify-content-start mb-2"
          text={`Contract language and attachments are kept per payer. Switch to "Only this payer" to edit this payer's.`}
        />
      )}
      <Controller
        name="contractLanguage"
        control={control}
        render={({ field }) => (
          <ContractLanguageSection
            ruleType={ruleType}
            ruleId={ruleId}
            attachments={attachments}
            value={field.value || ""}
            onChange={field.onChange}
            disabled={readOnly}
          />
        )}
      />
    </>
  );
}
